<template id="main-page">
  <v-ons-page>
    <div class="page-container">
      <!-- <google-map
        ref="mapRef"
        :center="mapCenter"
        :zoom="zoom"
        :options="{
          clickableIcons: false,
          disableDefaultUI: true,
          styles: mapStyles
        }"
        @center_changed="mapCenterChanged"
        @zoom_changed="mapZoomChanged"
        @idle="sync"
      > -->
      <google-map
        ref="mapRef"
        :center="mapCenter"
        :zoom="zoom"
        :options="{
          clickableIcons: false,
          disableDefaultUI: true,
          styles: mapStyles
        }"
        @zoom_changed="mapZoomChanged"
        @idle="sync"
      >
        <user-location></user-location>
        <shop-markers></shop-markers>
      </google-map>

      <map-buttons @center_changed="mapCenterUpdated"></map-buttons>

      <buttons @userLocationClicked="returnToUserLocation"></buttons>

      <carousel @getShop="getShopId" @cardChanged="highlightAndPanToShop"></carousel>

      <shop-details-modal></shop-details-modal>

      <shop-list-modal @shopSelected="shopSelected"></shop-list-modal>

      <search-modal @userLocationClicked="returnToUserLocation"></search-modal>
    </div>
  </v-ons-page>
</template>

<script>
// import _ from "lodash"
import { gmapApi } from "vue2-google-maps"
import Buttons from "../components/Buttons"
import MapButtons from "../components/MapButtons"
import Carousel from "../components/Carousel"
import ShopDetailsModal from "../components/ShopDetailsModal"
import ShopMarkers from "../components/ShopMarkers"
import UserLocation from "../components/UserLocation"
import ShopListModal from "../components/ShopListModal"
import SearchModal from "../components/search/SearchModal"
// import { getList } from "../apis"
import { mapGetters, mapActions } from "vuex"

export default {
  data() {
    return {
      mapStyles: [
        {
          featureType: "poi",
          stylers: [
            {
              lightness: 50
            }
          ]
        }
      ],
      geolocationErrorDisplayed: false,
      geolocationError: "現在地を特定できませんでした。",
      showSearch: false,
      directlySearch: false,
      shopId: null,

      searchResult: null, // TODO: remove from here
      showEmptyHolder: false, // TODO: remove from here
      showLoading: false // TODO: remove from here
    }
  },

  methods: {
    mapCenterUpdated() {
      var pos = this.$refs.mapRef.$mapObject.getCenter();
      var lat = pos.lat();
      var lng = pos.lng();
      this.$refs.mapRef.$mapPromise.then(map => {
        // this.setIgnoreMapCenterChanges(true)
        this.setReportedMapCenter({ lat, lng })
        map.panTo({ lat, lng })
        this.setIgnoreMapCenterChanges(false)

        // setTimeout(() => {
        //   this.panToShop(this.shopId)
        // }, 1500)

      })
    },

    mapCenterChanged(newMapCenter) {
      const lat = newMapCenter.lat()
      const lng = newMapCenter.lng()

      this.setReportedMapCenter({ lat, lng })
    },

    mapZoomChanged(newZoom) {
      this.setZoom(newZoom)
    },

    returnToUserLocation() {
      if (!this.userLocation) {
        this.$ons.notification.alert(this.geolocationError)
        return
      }

      this.$refs.mapRef.$mapPromise.then(map => {
        // add start btl
        const { lat, lng } = this.userLocation
        this.setReportedMapCenter({ lat, lng })
        this.setIgnoreMapCenterChanges(false)
        // add end btl
        map.panTo(this.userLocation)
      })
    },

    shopSelected(shopId) {
      this.closeModal()

      setTimeout(() => {
        this.highlightAndPanToShop(shopId)
      }, 150)
    },

    geolocate() {
      if (!navigator.geolocation) {
        this.$ons.notification.alert(this.geolocationError)
        return
      }

      navigator.geolocation.watchPosition(
        location => {
          const {
            coords: { latitude: lat, longitude: lng, accuracy: acc }
          } = location
          const firstGeolocation = this.firstLocation

          this.setUserLocation({ acc, lat, lng })

          if (firstGeolocation) {
            this.returnToUserLocation()
            this.requestHighlightReset()

            if (this.directlySearch) {
              this.initSearch().then(() => {
                this.searchMerchants()
                this.setCancellable(true)
                this.requestSearchScreen()
              })
            }
          }
        },
        () => {
          if (!this.geolocationErrorDisplayed) {
            if (this.directlySearch) {
              this.geolocationErrorDisplayed = true
              this.initSearch().then(() => {
                this.searchMerchants()
                this.setCancellable(true)
                this.requestSearchScreen()
              })
            } else {
              this.geolocationErrorDisplayed = true
              this.$ons.notification.alert(this.geolocationError)
            }
          }
        },
        {
          enableHighAccuracy: true
        }
      )
    },

    highlightAndPanToShop(shopId) {
      this.setHighlightedShopId(shopId)

      if (this.highlightedShop === null) {
        return
      }

      const { latitude: lat, longitude: lng } = this.highlightedShop

      this.$refs.mapRef.$mapPromise.then(map => {
        this.setIgnoreMapCenterChanges(true)

        map.panTo({ lat, lng })
        this.google.maps.event.addListenerOnce(map, "idle", () => {
          setTimeout(() => {
            this.setIgnoreMapCenterChanges(false)
          }, 50)
        })
      })
    },

    panToShop(shopId) {
      this.setHighlightedShopId(shopId)

      if (this.highlightedShop === null) {
        return
      }
      const { latitude: lat, longitude: lng } = this.highlightedShop
      this.$refs.mapRef.$mapPromise.then(map => {
        this.setReportedMapCenter({ lat, lng })
        map.panTo({ lat, lng })
      })
    },

    getShopId(shop_id) {
      this.shopId = shop_id
    },

    ...mapActions("map", [
      "setIgnoreMapCenterChanges",
      "setReportedMapCenter",
      "setUserLocation",
      "setZoom",
      "sync"
    ]),
    ...mapActions("search", ["initSearch", "couponForced", "setCancellable"]),
    ...mapActions("stores", [
      "searchMerchants",
      "setHighlightedShopId",
      "requestHighlightReset"
    ]),
    ...mapActions("nav", ["closeModal", "requestSearchScreen"])
  },

  computed: {
    google: gmapApi,
    ...mapGetters("map", [
      "firstLocation",
      "ignoreMapCenterChanges",
      "mapCenter",
      "userLocation",
      "zoom"
    ]),
    ...mapGetters("stores", [
      "sortedShops",
      "highlightedShopId",
      "highlightedShop"
    ]),
    ...mapGetters("nav", ["showShopListScreen", "showSearchScreen"])
  },

  created() {
    this.initSearch()
    this.sync()
    this.geolocate()

    const urlParams = new URLSearchParams(window.location.search)
    const coupon = urlParams.get("searchCoupons")

    if (coupon) {
      this.directlySearch = true
      this.couponForced(coupon)
    }

    document.addEventListener(
      "touchstart",
      event => {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      },
      { passive: false }
    )

    let lastTouchEnd = 0
    document.addEventListener(
      "touchend",
      event => {
        const now = new Date().getTime()

        if (now - lastTouchEnd <= 300) {
          event.preventDefault()
        }

        lastTouchEnd = now
      },
      false
    )
  },

components: {
    Buttons,
    MapButtons,
    Carousel,
    ShopListModal,
    ShopDetailsModal,
    ShopMarkers,
    UserLocation,
    SearchModal
  }
}

</script>

<style src="../styles/common.css"></style>
<style src="../styles/Modal.css"></style>

<style>
.vue-map-container {
  width: 100% !important;
  height: 100% !important;
}
</style>

<style scoped>
.vue-map-container,
.content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
